import { useQuery } from '@tanstack/react-query'
import {
  listTimeClocks,
  ListTimeClocksParams,
} from 'api/admin/timeClock/listTimeClocks'
import { timeClockKeys } from './keys'

export function useTimeClocksQuery(
  params: ListTimeClocksParams | null,
  options: { enabled?: boolean } = {}
) {
  return useQuery({
    queryKey: timeClockKeys.list(params ?? undefined),
    queryFn: () => {
      if (params === null) {
        throw new Error('companyId is required to list time clocks')
      }
      return listTimeClocks(params)
    },
    enabled: options.enabled ?? params !== null,
    // Only reuse a previous page's data (e.g. while paging via a new cursor)
    // when the companyId/locationId filters are unchanged. Otherwise a
    // company/location switch must not render the previous selection's rows
    // -- that would make Deregister actionable on stale, mismatched rows.
    placeholderData: (previousData, previousQuery) => {
      const previousParams = previousQuery?.queryKey[2] as
        | ListTimeClocksParams
        | undefined
      if (
        previousParams?.companyId === params?.companyId &&
        previousParams?.locationId === params?.locationId
      ) {
        return previousData
      }
      return undefined
    },
  })
}
